{
    "welcome": "Welcome",
    "getStarted": "Get started"
}
